import * as React from 'react';
import {
    BackButton,
    BackButtonIconType,
    BodyLargeRegular,
    View,
    XStack,
} from 'smoothie';

interface BillsHeaderProps {
    title: string;
    onBack: () => void;
    padding?: number;
}

const BillsHeader = ({ title, onBack, padding }: BillsHeaderProps) => {
    return (
        <XStack
            width="100%"
            alignItems="center"
            justifyContent="space-between"
            paddingHorizontal={padding ?? undefined}
        >
            <BackButton
                customBackFn={onBack}
                iconType={BackButtonIconType.X}
                style={{ paddingHorizontal: 0 }}
            />
            <BodyLargeRegular>{title}</BodyLargeRegular>
            <View width={16} height={34} />
        </XStack>
    );
};

export default BillsHeader;
